/* ============================================================
   Hello Foxi â€” GSAP Animations
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    if (window.__helloFoxiAnimsInit) return;
    window.__helloFoxiAnimsInit = true;
    if (typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var EASE = 'power3.out';
    var DUR  = 1;
    var SCROLL_DELAY = 0.2; // pause before scroll-triggered animations start playing
    
    // Split text into words (kept whole) â†’ each word contains per-char spans
    function splitChars(el) {
        var text = el.textContent;
        el.textContent = '';
        var chars = [];

        var words = text.split(' ');
        words.forEach(function (word, wi) {
            // word wrapper â€” won't break internally
            var wordSpan = document.createElement('span');
            wordSpan.className = 'word';
            wordSpan.style.display = 'inline-block';
            wordSpan.style.whiteSpace = 'nowrap';

            word.split('').forEach(function (ch) {
                var span = document.createElement('span');
                span.className = 'char';
                span.textContent = ch;
                span.style.display = 'inline-block';
                span.style.willChange = 'transform, opacity';
                wordSpan.appendChild(span);
                chars.push(span);
            });

            el.appendChild(wordSpan);

            // add a real space between words (breakable, so lines still wrap normally)
            if (wi < words.length - 1) {
                el.appendChild(document.createTextNode(' '));
            }
        });

        return chars;
    }

    function run(fn) {
        try { fn(); } catch (e) { console.warn('Animation module failed:', e); }
    }

    function revealOnScroll(targets, opts) {
        opts = opts || {};
        if (!document.querySelector(targets)) return;
        gsap.from(targets, {
            y: opts.y || 40, opacity: 0, duration: opts.duration || DUR,
            ease: EASE, stagger: opts.stagger || 0, delay: opts.delay != null ? opts.delay : SCROLL_DELAY,
            scrollTrigger: { trigger: opts.trigger || targets, start: opts.start || 'top 82%', toggleActions: 'play none none none' }
        });
    }

    /* -------- Home Banner -------- */
    run(function () {
        if (!document.querySelector('.home-banner')) return;
        var tl = gsap.timeline({ delay: 0.2 });
        tl.from('.home-banner .tag', { y: 24, opacity: 0, duration: 0.9, ease: EASE })
          .from('.home-banner .banner-content p', { y: 24, opacity: 0, duration: 0.9, ease: EASE }, '-=0.7')
          .from('.home-banner .btn-wrapper .btn', {
                y: 20, opacity: 0, duration: 0.8, stagger: 0.12, ease: EASE,
                clearProps: 'opacity,transform'
            }, '-=0.6');

        var lower = gsap.utils.toArray('.home-banner .lower-banner li');
        if (lower.length) {
            gsap.from(lower, { y: 18, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.1, delay: SCROLL_DELAY,
                scrollTrigger: { trigger: '.lower-banner', start: 'top 92%' } });
        }
    });
    
    /* -------- Home Banner heading: vibrate + fade-in per char -------- */
    run(function () {
        var heading = document.querySelector('.home-banner .banner-content h1');
        if (!heading) return;
    
        var chars = splitChars(heading);
    
        gsap.from(chars, {
            opacity: 0,
            y: 35,
            duration: 1,
            stagger: 0.04,
            ease: "power3.out"
        });
    });

    /* -------- Trust Bar -------- */
    run(function () {
        var items = gsap.utils.toArray('.trust-item');
        if (!items.length) return;
        gsap.from(items, { y: 22, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.1, delay: SCROLL_DELAY,
            scrollTrigger: { trigger: '.trust-bar', start: 'top 88%' } });
    });

    /* -------- Pathways -------- */
    run(function () {
        if (!document.querySelector('.pathways')) return;
        revealOnScroll('.pathways .section-heading', { trigger: '.pathways-head' });
        revealOnScroll('.pathways-intro', { trigger: '.pathways-head', y: 30 });
        var cards = gsap.utils.toArray('.pathways .path-card');
        if (cards.length) {
            gsap.from(cards, { y: 60, opacity: 0, duration: 1, ease: EASE, stagger: 0.3, delay: SCROLL_DELAY,
                scrollTrigger: { trigger: '.pathways-grid', start: 'top 80%' } });
        }
    });

    /* -------- Wellness Path -------- */
    run(function () {
        var section = document.querySelector('.wellness-path');
        if (!section || section.classList.contains('inner-wellness-path')) return;
        var tl = gsap.timeline({
            delay: SCROLL_DELAY,
            scrollTrigger: {
                trigger: section,
                start: 'top 78%'
            }
        });
        if (document.querySelector('.wellness-path .section-heading > *'))
            tl.from('.wellness-path .section-heading > *', { y: 30, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.1 });
        if (document.querySelector('.wp-tab'))
            tl.from('.wp-tab', { y: 20, opacity: 0, duration: 0.6, ease: EASE, stagger: 0.06, clearProps: 'transform,opacity' }, '-=0.3');
        var activeCards = gsap.utils.toArray('.wp-panel.active .wp-card');
        if (activeCards.length)
            tl.from(activeCards, { y: 40, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.12, clearProps: 'transform,opacity' }, '-=0.2');
    });

    /* -------- Transform -------- */
    run(function () {
        var section = document.querySelector('.transform');
        if (!section) return;
        if (document.querySelector('.transform-img'))
            gsap.from('.transform-img', { scale: 1.12, duration: 1.4, ease: EASE, delay: SCROLL_DELAY,
                scrollTrigger: { trigger: section, start: 'top 80%' } });
        if (document.querySelector('.transform-content-inner > *'))
            gsap.from('.transform-content-inner > *', { y: 34, opacity: 0, duration: 0.9, ease: EASE, stagger: 0.12, delay: SCROLL_DELAY,
                scrollTrigger: { trigger: section, start: 'top 72%' } });
    });

    /* -------- Difference -------- */
    run(function () {
        var section = document.querySelector('.difference');
        if (!section) return;
        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: section, start: 'top 74%' } });
        if (document.querySelector('.difference-eyebrow')) tl.from('.difference-eyebrow', { y: 20, opacity: 0, duration: 0.7, ease: EASE });
        if (document.querySelector('.difference-heading h2')) tl.from('.difference-heading h2', { y: 36, opacity: 0, duration: 0.9, ease: EASE, stagger: 0.12 }, '-=0.4');
        if (document.querySelector('.difference-divider')) tl.from('.difference-divider', { scaleX: 0, transformOrigin: 'center', duration: 0.6, ease: EASE }, '-=0.3');
        if (document.querySelector('.difference-body')) tl.from('.difference-body', { y: 24, opacity: 0, duration: 0.8, ease: EASE }, '-=0.3');
        if (document.querySelector('.diff-feature')) tl.from('.diff-feature', { y: 30, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.1 }, '-=0.3');
    });

    /* -------- Journey -------- */
    run(function () {
        var section = document.querySelector('.journey');
        if (!section) return;
        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: section, start: 'top 72%' } });
        if (document.querySelector('.journey-eyebrow')) tl.from('.journey-eyebrow', { y: 20, opacity: 0, duration: 0.7, ease: EASE });
        if (document.querySelector('.journey-heading h2')) tl.from('.journey-heading h2', { y: 40, opacity: 0, duration: 1, ease: EASE, stagger: 0.12 }, '-=0.4');
        if (document.querySelector('.journey-divider')) tl.from('.journey-divider', { scaleX: 0, transformOrigin: 'left', duration: 0.6, ease: EASE }, '-=0.4');
        if (document.querySelector('.journey-sub')) tl.from('.journey-sub', { y: 24, opacity: 0, duration: 0.8, ease: EASE }, '-=0.3');
        if (document.querySelector('.journey-btn')) tl.from('.journey-btn', { y: 20, opacity: 0, scale: 0.95, duration: 0.7, ease: 'back.out(1.5)' }, '-=0.3');
        if (document.querySelector('.journey-note')) tl.from('.journey-note', { opacity: 0, duration: 0.6, ease: EASE }, '-=0.2');
        var bg = section.querySelector('.journey-bg');
        if (bg) gsap.to(bg, { yPercent: 10, ease: 'none',
            scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true } });
    });

    /* -------- Collection Banner -------- */
    run(function() {
        var section = document.querySelector('.collection-banner');
        if (!section) return;
        var tl = gsap.timeline({
            delay: 0.2
        });
        tl.from('.cb-eyebrow', {
                y: 20,
                opacity: 0,
                duration: 0.8,
                ease: EASE
            })
            .from('.cb-content h1', {
                y: 44,
                opacity: 0,
                duration: 1.1,
                ease: EASE
            }, '-=0.5')
            .from('.cb-text', {
                y: 24,
                opacity: 0,
                duration: 0.9,
                ease: EASE
            }, '-=0.7')
            .from('.cb-btn', {
                y: 20,
                opacity: 0,
                duration: 0.8,
                ease: EASE,
                clearProps: 'opacity,transform'
            }, '-=0.6')
            .from('.cb-stats li', {
                y: 20,
                opacity: 0,
                duration: 0.7,
                ease: EASE,
                stagger: 0.12
            }, '-=0.5');
    });

    /* -------- Collection Tabs (Bootstrap wp-card grid) -------- */
    run(function () {
        var section = document.querySelector('.inner-wellness-path');
        if (!section) return;
        revealOnScroll('.inner-wellness-path .section-heading > *', {
            trigger: '.inner-wellness-path .section-heading', stagger: 0.1
        });
        revealOnScroll('.inner-wellness-path .wp-sub', { trigger: '.inner-wellness-path .section-heading' });
        revealOnScroll('.collection-tabs .nav-link', { trigger: '.collection-tabs', y: 16, stagger: 0.08 });

        // Animate cards on initial load â€” all together, no stagger
        var activeCards = gsap.utils.toArray('.tab-pane.active .wp-card');
        if (activeCards.length) {
            gsap.from(activeCards, {
                y: 40, opacity: 0, duration: 0.8, ease: EASE, delay: SCROLL_DELAY,
                scrollTrigger: { trigger: '.collection-content', start: 'top 78%' }
            });
        }

        // Re-animate cards whenever a Bootstrap tab is switched â€” all together, no stagger
        document.querySelectorAll('#myTab button[data-bs-toggle="tab"]').forEach(function (btn) {
            btn.addEventListener('shown.bs.tab', function (e) {
                var paneId = e.target.getAttribute('data-bs-target');
                var cards = gsap.utils.toArray(paneId + ' .wp-card');
                if (cards.length) {
                    gsap.from(cards, { y: 30, opacity: 0, duration: 0.6, ease: EASE });
                }
            });
        });
    });

    /* -------- Philosophy -------- */
    run(function() {
        var section = document.querySelector('.philosophy');
        if (!section) return;
        var tl = gsap.timeline({
            delay: SCROLL_DELAY,
            scrollTrigger: {
                trigger: section,
                start: 'top 76%'
            }
        });
        tl.from('.philosophy-content h6', {
                y: 20,
                opacity: 0,
                duration: 0.7,
                ease: EASE
            })
            .from('.philosophy-content h3', {
                y: 34,
                opacity: 0,
                duration: 0.9,
                ease: EASE
            }, '-=0.4')
            .from('.philosophy-content p', {
                y: 24,
                opacity: 0,
                duration: 0.8,
                ease: EASE
            }, '-=0.4')
            .from('.philosophy-img', {
                scale: 1.1,
                opacity: 0,
                duration: 1.2,
                ease: EASE
            }, '-=0.8');
    });

    /* -------- Founder -------- */
    run(function() {
        var section = document.querySelector('.founder');
        if (!section) return;
        var tl = gsap.timeline({
            delay: SCROLL_DELAY,
            scrollTrigger: {
                trigger: section,
                start: 'top 76%'
            }
        });
        tl.from('.founder .section-heading h6', {
                y: 20,
                opacity: 0,
                duration: 0.7,
                ease: EASE
            })
            .from('.founder-img img', {
                scale: 1.1,
                opacity: 0,
                duration: 1.1,
                ease: EASE
            }, '-=0.3')
            .from('.founder-lower', {
                y: 20,
                opacity: 0,
                duration: 0.7,
                ease: EASE
            }, '-=0.6')
            .from('.founder-content h3', {
                y: 30,
                opacity: 0,
                duration: 0.9,
                ease: EASE
            }, '-=0.6')
            .from('.founder-content > p', {
                y: 24,
                opacity: 0,
                duration: 0.8,
                ease: EASE,
                stagger: 0.1
            }, '-=0.6')
            .from('.founder-content ul li', {
                y: 20,
                opacity: 0,
                duration: 0.6,
                ease: EASE,
                stagger: 0.1
            }, '-=0.4')
            .from('.founder-right img', {
                scale: 1.1,
                opacity: 0,
                duration: 1.1,
                ease: EASE
            }, '-=0.9');
    });

    /* -------- Unique Hero -------- */
    run(function() {
        var section = document.querySelector('.unique-hero');
        if (!section) return;
        var tl = gsap.timeline({
            delay: SCROLL_DELAY,
            scrollTrigger: {
                trigger: section,
                start: 'top 74%'
            }
        });
        tl.from('.uh-badge', {
                y: 20,
                opacity: 0,
                duration: 0.7,
                ease: EASE
            })
            .from('.uh-line', {
                y: 34,
                opacity: 0,
                duration: 0.9,
                ease: EASE,
                stagger: 0.15
            }, '-=0.4')
            .from('.uh-text', {
                y: 24,
                opacity: 0,
                duration: 0.8,
                ease: EASE
            }, '-=0.5')
            .from('.uh-btn', {
                y: 20,
                opacity: 0,
                scale: 0.95,
                duration: 0.7,
                ease: 'back.out(1.5)'
            }, '-=0.4')
            .from('.uh-note', {
                opacity: 0,
                duration: 0.6,
                ease: EASE
            }, '-=0.2');
        var bg = section.querySelector('.uh-bg');
        if (bg) gsap.to(bg, {
            yPercent: 10,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    });

    /* -------- Journey Hero (collections version) -------- */
    run(function() {
        var section = document.querySelector('.journey-hero');
        if (!section) return;
        var tl = gsap.timeline({
            delay: SCROLL_DELAY,
            scrollTrigger: {
                trigger: section,
                start: 'top 74%'
            }
        });
        tl.from('.jh-eyebrow', {
                y: 20,
                opacity: 0,
                duration: 0.7,
                ease: EASE
            })
            .from('.jh-line', {
                y: 40,
                opacity: 0,
                duration: 1,
                ease: EASE,
                stagger: 0.12
            }, '-=0.4')
            .from('.jh-text', {
                y: 24,
                opacity: 0,
                duration: 0.8,
                ease: EASE
            }, '-=0.4')
            .from('.jh-btn', {
                y: 20,
                opacity: 0,
                duration: 0.7,
                ease: EASE,
                stagger: 0.1,
                clearProps: 'opacity,transform'
            }, '-=0.3')
            .from('.jh-trust', {
                opacity: 0,
                duration: 0.6,
                ease: EASE
            }, '-=0.2');
        var bg = section.querySelector('.jh-bg');
        if (bg) gsap.to(bg, {
            yPercent: 10,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true
            }
        });
    });

    /* -------- Story Hero -------- */
    run(function () {
        var section = document.querySelector('.story-hero');
        if (!section) return;
        var tl = gsap.timeline({ delay: 0.2 });
        tl.from('.story-hero .story-eyebrow', { y: 20, opacity: 0, duration: 0.8, ease: EASE })
          .from('.story-hero .story-heading span', { y: 40, opacity: 0, duration: 1, ease: EASE, stagger: 0.12 }, '-=0.5')
          .from('.story-hero .story-text', { y: 24, opacity: 0, duration: 0.9, ease: EASE }, '-=0.6')
          .from('.story-hero .story-buttons a', { y: 20, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.1, clearProps: 'opacity,transform' }, '-=0.6')
          .from('.story-media img', { scale: 1.1, opacity: 0, duration: 1.2, ease: EASE }, '-=0.9')
          .from('.story-quote', { y: 20, opacity: 0, duration: 0.8, ease: EASE }, '-=0.5');
    });

    /* -------- Story Origin -------- */
    run(function () {
        var section = document.querySelector('.story-origin');
        if (!section) return;
        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: section, start: 'top 76%' } });
        tl.from('.story-origin-media img', { scale: 1.1, opacity: 0, duration: 1.2, ease: EASE })
          .from('.story-origin .story-eyebrow', { y: 20, opacity: 0, duration: 0.7, ease: EASE }, '-=0.8')
          .from('.story-origin-heading span', { y: 34, opacity: 0, duration: 0.9, ease: EASE, stagger: 0.12 }, '-=0.5')
          .from('.story-origin-label', { y: 20, opacity: 0, duration: 0.7, ease: EASE }, '-=0.5')
          .from('.story-origin-body p', { y: 24, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.1 }, '-=0.4');
    });

    /* -------- Advisory -------- */
    run(function () {
        var section = document.querySelector('.advisory');
        if (!section) return;
        revealOnScroll('.advisory-head > *', { trigger: '.advisory-head', stagger: 0.1 });

        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: '.advisory-profile', start: 'top 78%' } });
        tl.from('.advisory-media img', { scale: 1.1, opacity: 0, duration: 1.2, ease: EASE })
          .from('.advisory-name', { y: 24, opacity: 0, duration: 0.8, ease: EASE }, '-=0.8')
          .from('.advisory-role', { y: 20, opacity: 0, duration: 0.7, ease: EASE }, '-=0.5')
          .from('.advisory-line', { scaleX: 0, transformOrigin: 'left', duration: 0.6, ease: EASE }, '-=0.4')
          .from('.advisory-text p', { y: 20, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.1 }, '-=0.3');

        revealOnScroll('.advisory-quote > *', { trigger: '.advisory-quote', stagger: 0.1, y: 24 });
    });

    /* -------- Founder Quote -------- */
    run(function () {
        var section = document.querySelector('.founder-quote');
        if (!section) return;
        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: section, start: 'top 78%' } });
        tl.from('.fq-text', { y: 30, opacity: 0, duration: 0.9, ease: EASE })
          .from('.fq-divider', { scaleX: 0, transformOrigin: 'center', duration: 0.6, ease: EASE }, '-=0.3')
          .from('.fq-author', { opacity: 0, duration: 0.6, ease: EASE }, '-=0.2');
    });

    /* -------- Quality -------- */
    run(function () {
        var section = document.querySelector('.quality');
        if (!section) return;
        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: section, start: 'top 76%' } });
        tl.from('.quality .story-eyebrow', { y: 20, opacity: 0, duration: 0.7, ease: EASE })
          .from('.quality-heading span', { y: 34, opacity: 0, duration: 0.9, ease: EASE, stagger: 0.12 }, '-=0.4')
          .from('.quality-body p', { y: 20, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.08 }, '-=0.4')
          .from('.quality-media img', { scale: 1.1, opacity: 0, duration: 1.2, ease: EASE }, '-=1');
    });

    /* -------- Physician Care -------- */
    run(function () {
        var section = document.querySelector('.physician-care');
        if (!section) return;
        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: section, start: 'top 76%' } });
        tl.from('.pc-care-media img', { scale: 1.1, opacity: 0, duration: 1.2, ease: EASE })
          .from('.physician-care .story-eyebrow', { y: 20, opacity: 0, duration: 0.7, ease: EASE }, '-=0.8')
          .from('.pc-care-heading', { y: 30, opacity: 0, duration: 0.9, ease: EASE }, '-=0.5')
          .from('.pc-care-body p', { y: 20, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.08 }, '-=0.4');
    });

    /* -------- Commitments -------- */
    run(function () {
        var section = document.querySelector('.commitments');
        if (!section) return;
        revealOnScroll('.commitments-head > *', { trigger: '.commitments-head', stagger: 0.1 });
        var cards = gsap.utils.toArray('.commit-card');
        if (cards.length) {
            gsap.from(cards, {
                y: 40, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.1, delay: SCROLL_DELAY,
                scrollTrigger: { trigger: '.commitments-grid', start: 'top 80%' }
            });
        }
    });

    /* -------- Stories CTA -------- */
    run(function () {
        var section = document.querySelector('.stories-cta');
        if (!section) return;
        var tl = gsap.timeline({ delay: SCROLL_DELAY, scrollTrigger: { trigger: section, start: 'top 78%' } });
        tl.from('.sc-eyebrow', { y: 20, opacity: 0, duration: 0.7, ease: EASE })
          .from('.sc-heading span', { y: 34, opacity: 0, duration: 0.9, ease: EASE, stagger: 0.12 }, '-=0.4')
          .from('.sc-text', { y: 22, opacity: 0, duration: 0.8, ease: EASE }, '-=0.5')
          .from('.sc-buttons a', { y: 20, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.1, clearProps: 'opacity,transform' }, '-=0.4');
    });

    /* -------- Contact Header -------- */
    run(function () {
        var section = document.querySelector('.contact-header');
        if (!section) return;
        var tl = gsap.timeline({ delay: 0.2 });
        tl.from('.contact-header .section-heading h6', { y: 20, opacity: 0, duration: 0.7, ease: EASE })
          .from('.contact-header .ch-divider', { scaleX: 0, transformOrigin: 'center', duration: 0.6, ease: EASE }, '-=0.3')
          .from('.contact-header .section-heading h2', { y: 34, opacity: 0, duration: 0.9, ease: EASE }, '-=0.3')
          .from('.contact-header .ch-text', { y: 22, opacity: 0, duration: 0.8, ease: EASE }, '-=0.5');
        if (document.querySelector('.contact-header .cat-hero-badge'))
            tl.from('.contact-header .cat-hero-badge', { y: 18, opacity: 0, duration: 0.6, ease: EASE }, '-=0.4');
    });

    /* -------- Contact Cards -------- */
    run(function () {
        var cards = gsap.utils.toArray('.cc-card');
        if (!cards.length) return;
        gsap.from(cards, {
            y: 40, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.12, delay: SCROLL_DELAY,
            clearProps: 'transform,opacity',
            scrollTrigger: { trigger: '.contact-cards', start: 'top 80%' }
        });
    });

    /* -------- FAQ -------- */
    run(function () {
        var section = document.querySelector('.faq');
        if (!section) return;
        revealOnScroll('.faq-head > *', { trigger: '.faq-head', stagger: 0.1 });

        var items = gsap.utils.toArray('.faq-item');
        if (items.length) {
            gsap.from(items, {
                y: 30, opacity: 0, duration: 0.7, ease: EASE, stagger: 0.1, delay: SCROLL_DELAY,
                scrollTrigger: { trigger: '.faq-accordion', start: 'top 82%' }
            });
        }
    });

    /* -------- Shop Grid -------- */
    run(function () {
        var section = document.querySelector('.shop');
        if (!section) return;
        var cards = gsap.utils.toArray('.wp-products .wp-card');
        if (!cards.length) return;
        gsap.from(cards, {
            y: 40, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.1, delay: SCROLL_DELAY,
            clearProps: 'transform,opacity',
            scrollTrigger: { trigger: '.wp-products', start: 'top 85%' }
        });
    });

    /* -------- Hub Grid -------- */
    run(function () {
        var section = document.querySelector('.hub');
        if (!section) return;
        var cards = gsap.utils.toArray('.hub-card');
        if (!cards.length) return;
        gsap.from(cards, {
            y: 40, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.12, delay: SCROLL_DELAY,
            clearProps: 'transform,opacity',
            scrollTrigger: { trigger: '.hub-grid', start: 'top 80%' }
        });
    });

    /* -------- Category Group -------- */
    run(function () {
        var section = document.querySelector('.cat-group');
        if (!section) return;
        revealOnScroll('.cat-group-head > *', { trigger: '.cat-group-head', stagger: 0.1 });

        var cards = gsap.utils.toArray('.cat-card');
        if (cards.length) {
            gsap.from(cards, {
                y: 40, opacity: 0, duration: 0.8, ease: EASE, stagger: 0.1, delay: SCROLL_DELAY,
                clearProps: 'transform,opacity',
                scrollTrigger: { trigger: '.cat-group .row.g-4', start: 'top 82%' }
            });
        }
    });

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
});